import { useQuery } from '@tanstack/react-query';

import { fetchOCClaimPrintForm } from '../data-provider/over-charge-print-form';
import type { GetOCClaimPrintFormRequestParams } from '../data-provider/over-charge-print-form/api';

export const useGetOverChargePrintForm = ({
  enabled = true,
  ...params
}: GetOCClaimPrintFormRequestParams & { enabled?: boolean }) => {
  return useQuery({
    enabled: enabled && Boolean(params.FBOCKey),
    queryFn: () => fetchOCClaimPrintForm(params),
    queryKey: ['over-charge-print-form', params.FBOCKey],
  });
};
